// @flow
import * as React from 'react';
import cx from 'classnames';

import cs from './style.pcss';

type Props = {
  children: React.Node,
  className?: string,
  mode: 'success' | 'main' | 'warning',
};

export default function Marker({
  children,
  className,
  mode,
}: Props): React.Node {
  return <div className={cx(cs.marker, cs[mode], className)}>{children}</div>;
}
